var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",style:({
    width: `${_vm.percent}%`,
    height: _vm.height,
    opacity: _vm.show ? 1 : 0,
    'background-color': _vm.canSuccess ? _vm.color : _vm.failedColor,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }